import { types } from './actions';

export default function analyticsReducer(
  state = {
    filterObj: null,
  },
  action
) {
  switch (action.type) {
    case types.LOAD_ALL_DATA: {
      const { data = {} } = action;
      return { ...state, ...data };
    }
    case types.LOAD_DATA_OF_A_QUADRANT: {
      const { data = {}, apiSource } = action;
      return { ...state, [apiSource]: data };
    }
    case types.APPLIED_FILTER: {
      const { filterObj = {} } = action;
      return { ...state, filterObj };
    }
    case types.SELECTED_TASK: {
      const { taskObj = {} } = action;
      return { ...state, taskObj };
    }
    default:
      return state;
  }
}
